import React from 'react'; 
import Dict from '../providers/Dict'
import LocalStorage from '../providers/LocalStorage';
// import Theme from '../providers/Theme';

export default class SpecificComponent extends React.Component{
    constructor(props){
        super(props);

        let LS = new LocalStorage();
        this.userData = LS.GetUserData();
        this.userPreferences = LS.GetUserPreferences();

        let DCT = new Dict()
        if(this.userPreferences){
            if(this.userPreferences.language)
                this.dictionary=DCT.getDict( this.userPreferences.language )
            else
                this.dictionary=DCT.getDict( 'ro' )
        }
        else
            this.dictionary=DCT.getDict( 'ro' )

            // let TH = new Theme(this.userPreferences.theme || '')
            // this.theme = TH.theme

           
    }

    dictionary = null;
    userData = null;
    userPreferences = null;

    // theme = null;

    arataPopup = (succes,mesaj,timeout)=>{
        
    }

}  // end class